import * as React from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router-dom';
import CompanyDetailPage from './CompanyDetailPage';

interface RouteParams { 
  id: string; 
  url: string 
};

function CompanyDetail({ match }: RouteComponentProps<RouteParams>) {
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}/:companyId`}
        component={CompanyDetailPage}
      />
      <Route
        exact
        path={`${match.url}/:companyId/:tab`}
        component={CompanyDetailPage}
      />
    </Switch>
  );
}

export default CompanyDetail;
